import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	GateActions,
	GateCard,
	GateDescription,
	GateHero,
	GateHeroCopy,
	GateLayout,
	GatePrimaryButton,
	GateSecondaryButton,
	GateTitle,
	GateView,
} from './ChatGuestGate.styles';

import { STUDIO_HERO_IMAGE } from '@/common/constants/studioPublicMedia';

const CHAT_HERO_IMAGE = STUDIO_HERO_IMAGE;

const ChatGuestGate = ({ onRegister, onLogin }) => {
	const t = useLanguageData('chat');

	return (
		<GateView aria-labelledby="chatGuestGateTitle">
			<GateLayout>
				<GateHero aria-hidden="true">
					<img src={CHAT_HERO_IMAGE} alt="" />
					<GateHeroCopy>
						<h2>{t.guestGateHeroTitle}</h2>
						<p>{t.guestGateHeroDescription}</p>
					</GateHeroCopy>
				</GateHero>
				<GateCard>
					<GateTitle id="chatGuestGateTitle">{t.guestGateTitle}</GateTitle>
					<GateDescription>{t.guestGateDescription}</GateDescription>
					<GateActions>
						<GatePrimaryButton type="button" onClick={onRegister}>
							{t.guestGateRegister}
						</GatePrimaryButton>
						<GateSecondaryButton type="button" onClick={onLogin}>
							{t.guestGateLogin}
						</GateSecondaryButton>
					</GateActions>
				</GateCard>
			</GateLayout>
		</GateView>
	);
};

export default ChatGuestGate;
